module.exports = __webpack_public_path__ + "static/media/nao-encontrou-o-que-procurava.3b49732c.png";